export const readImageUploadResponse = (status: number, responseText: string): {
  ok: boolean
  error?: string
  uploadedImageIds: number[]
} => {
  const failed = { ok: false, uploadedImageIds: [] };
  try {
    const response: unknown = JSON.parse(responseText);
    if (response === null || typeof response !== 'object' || Array.isArray(response)) return failed;

    const { code, status: responseStatus, error, data } = response as Record<string, unknown>;
    const nested = data !== null && typeof data === 'object' && !Array.isArray(data)
      ? data as Record<string, unknown> : undefined;
    const errors = [nested?.error, error].filter(value => value !== undefined && value !== null && value !== '');
    const images = Array.isArray(data) ? data : nested?.images;
    const uploadedImageIds = Array.isArray(images) ? Array.from(new Set(images.flatMap((image: unknown) => {
      const id = image !== null && typeof image === 'object' ? (image as Record<string, unknown>).id : undefined;
      if (typeof id !== 'number' && !(typeof id === 'string' && /^[1-9]\d*$/.test(id))) return [];
      const number = Number(id);
      return Number.isSafeInteger(number) && number > 0 ? [number] : [];
    }))) : [];

    return {
      ok: status >= 200 && status < 300
        && (code === undefined || code === 200)
        && (responseStatus === undefined || responseStatus === 200)
        && errors.length === 0 && uploadedImageIds.length > 0,
      error: errors.find((value): value is string => typeof value === 'string'),
      uploadedImageIds,
    };
  } catch {
    return failed;
  }
};
